(function () {
   const HYPOTHESIS_ID = 'db719404-2b3f-456d-ba37-a9b2f7c46393';

   function setVariant(isB) {
      document.body.dataset.cartVariant = isB ? 'B' : 'A';
   }

   async function assign() {
      if (!window.shoplift || typeof window.shoplift.isHypothesisActive !== 'function') {
         setVariant(false);
         return;
      }
      try {
         const isB = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);
         setVariant(!!isB);
      } catch (e) {
         console.warn('Shoplift Zuweisung fehlgeschlagen, zeige A', e);
         setVariant(false);
      }
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', assign);
   } else {
      assign();
   }
})();
